import React from 'react';
import { IFontFamily, fontFamilies } from '../logic/text-test-logic';
import '../styles/font-family-picker.scss';
import { isEnter } from '../../shared/util/functions';

interface Props {
    onFontFamilyChange: (pickedFontFamily: IFontFamily) => void;
    selected: IFontFamily;
}

function getFontFamily(
    fontFamily: IFontFamily,
    isSelected: boolean,
    elKey: number,
    onClick: (pickedFontFamily: IFontFamily) => void
): any {
    return (
        <span
            key={elKey}
            tabIndex={0}
            className={"font-family__entity" + (isSelected ? ' font-family__entity--selected' : '')}
            style={{ fontFamily: fontFamily.cssEntity }}
            onKeyPress={evt => isEnter(evt) && onClick(fontFamily)}
            onClick={() => onClick(fontFamily)}
        >
            { fontFamily.name }
        </span>
    );
}

export const FontFamilyPicker: React.FunctionComponent<Props> = props => {

    const fonts = fontFamilies.map(
        (fontFamily: IFontFamily, i: number) =>
            getFontFamily(fontFamily, fontFamily.name === props.selected.name, i, props.onFontFamilyChange)
    );

    return (
        <div className={"font-family-picker"}>
            <span className={"font-family-picker__label"}>Schriftart:</span>
            { fonts }
        </div>
    );

};
